import { yup } from '@guiker/yup-util'

export const readOneUserByIdPath = yup.object({
  userId: yup.string().required(),
})
